import { Component } from "react";
import {
    DKInput,
    DKLabel,
    DKButton
} from "deskera-ui-library";
import Utility, { deepClone } from "../../utility/Utility";
import { INPUT_TYPE } from "../../constants/Constant";
export default class CustomFormField extends Component {
    canValidate = false;
    fields = deepClone(this.props.fields);
    
    updateState() {
        this.setState({
            ...this.state
        })
    }
    onSave = () => {
        this.updateState(); 
        setTimeout(()=>{
            if (!this.validateForm()) {
                this.updateState(); 
                return;
            }
            this.props.onSubmit(this.fields)
        },100)
    }
    validateForm() {
        let isValid = true;
        this.canValidate = true;
        this.fields?.filter(f=>!f.hidden).forEach(field => {
            if (field.required && field.type != INPUT_TYPE.NUMBER && Utility.isEmpty(field['value'])) {
                isValid = false;
            } else if (field.required && field.type == INPUT_TYPE.NUMBER && Utility.isEmpty(field['value'].toString()) ) {
                isValid = false;                
            } else if (!field.isValid) {
                isValid = false;
            }
        })
        
        return isValid
    }
    renderHeader() {
        return <div className="row justify-content-between">
            <DKLabel className="fw-m fs-l" text={this.props.title} />
            <div className="d-flex">
                <DKButton className="border-m bg-gray1 mr-s" title="cancel" onClick={() => this.props.onCancel()} />
                <DKButton className="bg-app text-white" title="Save" onClick={() => this.onSave()} />
            </div>
        </div>
    }
    validator(value,obj) {
        if (obj.validation && obj.validation.regExp) {
            const regex = new RegExp(obj.validation.regExp);
            obj.isValid = regex.test(value);
            return regex.test(value);
        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
            obj.isValid = false
            return false;
        } else if (obj.required && Utility.isEmpty(value)) {
            obj.isValid = false
            return false;
        } else {
            obj.isValid = true;
            return true;
        }
    }
    renderField(obj,index) {
        return (
            <>
                <DKInput

                    className={"p-v-s mb-r"}
                    icon={obj.icon}
                    title={obj?.name}
                    placeholder={obj?.name}
                    value={obj.value}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate || obj['canValidate']}
                    onChange={(value) => {
                        obj['canValidate'] = true;
                        obj['value'] = value
                    }}
                    validator={(value) => {
                        return this.validator(value,obj)
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return obj;
                    }}
                    // displayKey={"name"}
                    dropdownConfig={{
                        className: "",
                        checkMarkColor: "bg-app",
                        style: {},
                        // searchableKey:"name",
                        allowSearch :obj.options?.length > 6 ? true:false,
                        multiSelect: obj.multiSelect,
                        data: obj.options,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly}
                />
            </>
        )
    }
    renderForm() {
        return this.fields?.map((field,index)=>this.renderField(field,index))
    }
    render() {
        return (
            <>
            {this.renderHeader()}
            {this.renderForm()}
            </>
        )
    }
}